import React, { useMemo } from "react";
import "../App.css";
import "./Content.css";

export default function Content({ id }) {

  const balls = useMemo(() =>
    Array.from({ length: 8 }).map((_, i) => ({
      size: Math.random() * 300 + 100,
      top: Math.random() * 80 + "%",
      left: Math.random() * 80 + "%",
      opacity: Math.random() * 0.3 + 0.2,
      blur: Math.random() * 80 + 60,
      duration: Math.random() * 20,
      delay: 5,
      xMove: (Math.random() - 0.5) * 300,
      yMove: (Math.random() - 0.5) * 300,
    })), []
  );

  return (
    <div className="App" id={id}>
      <div className="hero">

        <style>{balls.map((ball, i) => `
          @keyframes floatBall${i} {
            from { transform: translate(0, 0); }
            to   { transform: translate(${ball.xMove}px, ${ball.yMove}px); }
          }
        `).join("")}</style>

        {balls.map((ball, index) => (
          <div
            key={index}
            className="purple-ball"
            style={{
              width: ball.size,
              height: ball.size,
              top: ball.top,
              left: ball.left,
              opacity: ball.opacity,
              filter: `blur(${ball.blur}px)`,
              animation: `floatBall${index} ${ball.duration}s ease-in-out infinite alternate`,
            }}
          />
        ))}

        <div className="hero-container">
          <div className="hero-info">
            <h3>Software Developer</h3>
            <h1>Emanuel Soares</h1>
            <p>
              Olá, estou empolgado para criar soluções.
              <br />
              Tenho 20 anos e quero aprender, experimentar e crescer a cada projeto.
            </p>
            <button onClick={() => document.getElementById("contact").scrollIntoView({ behavior: "smooth" })}>Fale Comigo</button>
          </div>

          <div className="hero-avatar">
            <img src="memoji.png" alt="memoji" />
          </div>
        </div>

        <div className="scroll-down">
          <svg width="24" height="40" viewBox="0 0 24 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="22" height="38" rx="11" stroke="#fff" strokeWidth="2" />
            <rect x="11" y="8" width="2" height="6" rx="1" fill="#fff" />
          </svg>
        </div>

      </div>
    </div>
  );
}